export default "__VITE_ASSET__$6r4IoAg__"